import Button from '@carvana/ds-button';
import cx from 'classnames';
import { useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import ObservableTile from './ObservableTile';

type OwnProps = {
  tileName: string;
  title: string | React.ReactNode;
  description: string;
  ctaCopy: string;
  imageProps?: React.ImgHTMLAttributes<HTMLImageElement>;
  anchorProps: React.AnchorHTMLAttributes<HTMLAnchorElement>;
  position?: number;
  classes?: {
    content?: string;
  };
};

export default function ConditionalTile({
  tileName,
  anchorProps,
  title,
  imageProps,
  description,
  ctaCopy,
  position,
  classes
}: OwnProps) {
  const trackEvent = useTrackEvent();
  const ref = useRef(null);

  return (
    <ObservableTile
      observeRef={ref}
      name={tileName}
      onVisible={() => {
        trackEvent('Conditional tile', {
          action: 'viewed',
          tile: tileName,
          position
        });
      }}
    >
      <a data-testid="conditional-tile-link" {...anchorProps}>
        <div className="flex justify-center rounded-md border border-border-subtle bg-background-default p-2xl shadow-sm hover:border-border-default sm:h-full">
          <div className="flex flex-col gap-2xl text-center sm:my-auto">
            <div className={cx('flex flex-col gap-lg', classes?.content)}>
              <img {...imageProps} className="mx-auto h-[86px] w-[120px]" />
              <div className="flex flex-col justify-center gap-lg">
                <h3 className="text-text-strong t-heading-lg sm:t-heading-xl">
                  {title}
                </h3>
                <p className="text-text-default t-body-sm">{description}</p>
              </div>
            </div>
            <Button
              aria-hidden="true"
              size="sm"
              className="w-full sm:mx-auto sm:w-fit"
              variant="primary"
              tabIndex={-1}
            >
              {ctaCopy}
            </Button>
          </div>
        </div>
      </a>
    </ObservableTile>
  );
}
